module.exports = __webpack_public_path__ + "img/1746687375654-WhatsApp Image 2025-05-08 at 14.54.35.jpeg.41bc7c52.webp";